import type { MyFeedbackEntry } from "@/presentation/rpc/feature-announcements-rpc"
import { toEpochMs } from "./format-relative-time"

/**
 * When Cova last did something on this thread that the user may not have seen.
 * Mirrors the two arms of the server's `deriveUnread`: a public team reply, or an
 * acknowledgement ("Seen by the Cova team") on a thread with no reply yet. Either
 * can be the thing that lit the unread dot, so both count.
 */
export function lastTeamSignalAt(item: MyFeedbackEntry): number {
  return Math.max(toEpochMs(item.latestTeamPublicMessageAt), toEpochMs(item.acknowledgedAt))
}

/**
 * The unread thread to land on when the widget opens. Newest team signal wins —
 * NOT list order, which is `created_at DESC` (when the user submitted) and would
 * pick an old ticket that happened to be raised later over the one Cova answered
 * a minute ago. Returns null when nothing is unread.
 */
export function pickNewestUnread<T extends { item: MyFeedbackEntry; unread: boolean }>(
  rows: ReadonlyArray<T>,
): T | null {
  let best: T | null = null
  let bestAt = -1
  for (const row of rows) {
    if (!row.unread) continue
    const at = lastTeamSignalAt(row.item)
    if (at > bestAt) {
      best = row
      bestAt = at
    }
  }
  return best
}
